import type { IconSvgObject } from './types';

const ChartSplineIcon: IconSvgObject = [
  ["path", { d: "M7 17C7 10.2174 8.43478 8 10 8C12.5 8 13.5 14 16 14C18.087 14 19 8.13043 19 5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartSplineIcon;
